import get from 'lodash/get';

import { getErrorMessage } from '../../../utils/errorMessage';

import { FoldersReducerType } from '../foldersState.types';
import {
  FolderDecision,
  FolderDecisionAnnotation,
} from '../../page/folders.types';

export const loadDecisionsState = (
  state: FoldersReducerType,
  folderKey: string,
) => ({
  ...state,
  folders: {
    ...state.folders,
    [folderKey]: {
      ...state.folders[folderKey],
      decisions: {
        ...state.folders[folderKey].decisions,
        loading: true,
      },
    },
  },
});

export const errorDecisionsState = (
  state: FoldersReducerType,
  folderKey: string,
  error: { response: {} },
) => ({
  ...state,
  folders: {
    ...state.folders,
    [folderKey]: {
      ...state.folders[folderKey],
      decisions: {
        decisions: [],
        loading: false,
        errorMessage: getErrorMessage(error.response),
      },
    },
  },
});

export const getDecisionsState = (
  state: FoldersReducerType,
  folderKey: string,
  decisions: FolderDecision[],
  size?: number,
) => ({
  ...state,
  folders: {
    ...state.folders,
    [folderKey]: {
      ...state.folders[folderKey],
      decisions: {
        loading: false,
        decisions: [
          ...get(state.folders[folderKey], ['decisions', 'decisions'], []),
          ...decisions,
        ],
        hasMore: decisions.length === size,
        currentIndex:
          get(state.folders[folderKey], ['decisions', 'currentIndex'], 0) +
          decisions.length,
      },
    },
  },
});

export const loadAnnotationsState = (
  state: FoldersReducerType,
  folderKey: string,
) => ({
  ...state,
  folders: {
    ...state.folders,
    [folderKey]: {
      ...state.folders[folderKey],
      annotations: {
        ...state.folders[folderKey].annotations,
        loading: true,
      },
    },
  },
});

export const errorAnnotationsState = (
  state: FoldersReducerType,
  folderKey: string,
  error: { response: {} },
) => ({
  ...state,
  folders: {
    ...state.folders,
    [folderKey]: {
      ...state.folders[folderKey],
      annotations: {
        annotations: [],
        loading: false,
        errorMessage: getErrorMessage(error.response),
      },
    },
  },
});

export const getAnnotationsState = (
  state: FoldersReducerType,
  folderKey: string,
  annotations: FolderDecisionAnnotation[],
) => ({
  ...state,
  folders: {
    ...state.folders,
    [folderKey]: {
      ...state.folders[folderKey],
      annotations: {
        annotations,
        loading: false,
      },
    },
  },
});
